import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import style from './ToggleEntry.css';
export var ToggleEntry = /*#__PURE__*/function (_Component) {
  _inherits(ToggleEntry, _Component);

  var _super = _createSuper(ToggleEntry);

  function ToggleEntry(_props) {
    var _this;

    _classCallCheck(this, ToggleEntry);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "_id", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "getCheckBoxId", function () {
      if (!_this._id) {
        _this._id = _this.props.id || '__checkbox_' + ++ToggleEntry.idCounter;
      }

      return _this._id;
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      e.preventDefault();
      var active = !_this.state.active;

      _this.setState({
        active: active
      });

      if (_this.props.onChange) {
        _this.props.onChange(active);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (props) {
      if (props.active != _this.state.active) {
        _this.setState({
          active: props.active
        });
      }
    });

    _this.state.active = _props.active || false;
    return _this;
  }

  _createClass(ToggleEntry, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("li", {
        className: style.toggleEntry
      }, /*#__PURE__*/React.createElement("a", {
        className: style['checkbox-holder'],
        onClick: this.onClick
      }, /*#__PURE__*/React.createElement("input", {
        id: this.getCheckBoxId(),
        type: "checkbox",
        checked: this.state.active,
        className: "checkbox",
        readOnly: true
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: this.getCheckBoxId()
      }, this.props.children)));
    }
  }]);

  return ToggleEntry;
}(Component);

_defineProperty(ToggleEntry, "idCounter", 0);